import Api from './modules/api'
import { Utility } from './modules/utility.js'

const utility = new Utility()
export default {
  data() {
    return {
      Api,
      utility
    }
  }
}
